<template>
  <div class="e-line">
  </div>
</template>
<script>
export default {
  name: 'e-line'
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/common';

.e-line {
  margin-bottom: 20px;
  width: 100%; height: 0;
  border-bottom: dashed 1px $grayBorder;
}

@media screen and (max-width: 768px) {
  .e-line {
    width: calc(100vw - 40px);
    margin: 0 auto 15px;
  }
}
</style>
